import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styles from "./SinglePersonTitle.module.scss";
import SonicLink from "../../common/routing/SonicLink";

type Props = {
  title: string;
  subTitle: string;
  report?: boolean;
};
const SinglePersonTitle: React.FC<Props> = ({
  title,
  subTitle,
  report = false,
}) => {
  return (
    <>
      <div className={styles["singlePersonTitle-title"]}>
        {title}
        {report ? (
          <SonicLink to="/contact" className={styles["report-btn"]}>
            <FontAwesomeIcon icon={["fas", "ban"]} />
            報告
          </SonicLink>
        ) : null}
      </div>
      <h3 className={styles["singlePersonTitle-subTitle"]}>{subTitle}</h3>
    </>
  );
};

export default SinglePersonTitle;
